import { EXPERIAN_FORM }  from "../constants";

const initialState = {}

const getExperianReducer = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case EXPERIAN_FORM.GET_EXPERIAN_DETAILS:
            return {
                 ...state,
                 ...payload
             }
        case EXPERIAN_FORM.GET_EXPERIAN_SUCCESS:
            return {
                ...payload
            }
        case EXPERIAN_FORM.GET_EXPERIAN_FAIL:
            return {
                ...payload
            }   
        default:
            return state;
    }
}

export default getExperianReducer;